import Dashboard from "./components/dashboard/Dashboard";
import Pages from "./components/others/Page";
import { useRoutes, Navigate } from 'react-router-dom';
import Sign from "./components/login/Sign"
import Signup from "./components/login/Signup";
import Reset from "./components/login/Reset";
import DashboardAdmin from "./admin/Dashboard"
import Register from "./register/Dashboard"
import React, { useEffect, useState } from 'react';
import { getLogin } from './redux/actions/userAction';
import axios from "axios";
import { useDispatch } from 'react-redux'
import Todorhoilt from "./components/todorhoilt/page"

function App() {
  const routes = useRoutes([
      { path: '/', element: <Dashboard /> },
      { path: '/definition', element: <Todorhoilt selected="definition" /> },
      { path: '/definition/list', element: <Todorhoilt selected="definitionList" /> },
      { path: '/request', element: <Pages selected="request"/> },
      { path: '/request-water', element: <Pages selected="request-water"/> },
      // { path: '/request-water/list', element: <Pages selected="request-water-list"/> },

      { path: '/services', element:<Pages selected="services"/> },
      { path: '/login', element: <Sign /> },
      { path: '/register', element: <Signup /> },
      { path: '/reset-password', element: <Reset /> },
      { path: '/admin/requests', element:  <DashboardAdmin selected="requests"  /> },
      { path: '/admin/users', element: <DashboardAdmin selected="users"  /> },
      { path: '/admin/settings', element: <DashboardAdmin selected="settings"  /> },
      { path: '/admin/paylists', element: <DashboardAdmin selected="paylists"  /> },
      { path: '/admin/dashboard', element: <DashboardAdmin selected="dashboard"  /> },
      { path: '/admin/definition', element: <DashboardAdmin selected="definition"  /> },
      { path: '/admin', element: <DashboardAdmin selected="dashboard"  /> },
      { path: '/user/register', element: <Register selected="requests"  /> },
      { path: '/user/definition', element: <Register selected="definition"  /> },
  ]);

  return routes;
}

export default App;
